import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_PRODUCTS_APP_ROOT = `${BASE_ADMIN_V2_PATH}/products`;

export const ADMIN_PRODUCTS_APP_PATHS = {
  PRODUCTS_LIST: `${ADMIN_PRODUCTS_APP_ROOT}`,
  PRODUCT_DETAILS: (productId: string) => `${ADMIN_PRODUCTS_APP_ROOT}/${productId}/details`,
};

export const PRODUCT_IMAGE_PATH = (path: string) => `${process.env.REACT_APP_AWS}/${path}`;
